const payWay = {
  code: 0,
  data: {
    payway:[
      {
        name: '微信支付',
        payId: 10001
      },
      {
        name: '支付宝支付',
        payId: 10002
      },
      {
        name: '银行卡支付',
        payId: 10003
      },
      {
        name: '银联支付',
        payId: 10004
      }
    ]
  },
  message: 'success'
}

const payMeal = {
  code: 0,
  data: {
    paymeal:[
      {
        label: '平台币100000点送1000点',
        payId: 20001
      },
      {
        label: '平台币1000000000点送1000000点',
        payId: 20002
      },
      {
        label: '平台币100000000000点送1000000点',
        payId: 20003
      },
      {
        label: '平台币10000000000000点送10000000点',
        payId: 20004
      }
    ]
  },
  message: 'success'
}


export default {
  getPayWay: () => {
    return payWay
  },
  getPayMeal: () => {
    return payMeal
  }
};



// WEBPACK FOOTER //
// ./src/mock/recharge.js